import React, { useEffect, useState } from 'react';
import { HeartHandshake } from 'lucide-react';
import { api, fileUrl } from '@/lib/api';

const initials = (name) => (name || '')
  .split(/\s+/).filter(Boolean).slice(0, 2).map((s) => s[0]).join('').toUpperCase();

const VolunteerCard = ({ item }) => {
  const role = item.assigned_type || item.preferred_role || 'Summit Volunteer';
  return (
    <div
      data-testid={`volunteer-card-${item.id}`}
      className="bg-white rounded-2xl p-5 border border-aawta-border hover:shadow-aawta-elevated hover:-translate-y-1 transition-all duration-300 flex flex-col items-center text-center"
    >
      <div className="w-24 h-24 rounded-full overflow-hidden ring-4 ring-aawta-magenta/20 bg-aawta-surface flex items-center justify-center">
        {item.headshot_file_id ? (
          <img src={fileUrl(item.headshot_file_id)} alt={item.full_name}
               className="w-full h-full object-cover" loading="lazy" />
        ) : (
          <div className="font-display font-bold text-2xl text-aawta-navy">
            {initials(item.full_name)}
          </div>
        )}
      </div>
      <div className="mt-4 font-display font-semibold text-aawta-navy text-[15.5px] leading-snug">
        {item.full_name}
      </div>
      <span className="mt-1.5 text-[10.5px] font-bold uppercase tracking-wider px-2.5 py-0.5 rounded-full bg-aawta-magenta/10 text-aawta-magenta">
        {role}
      </span>
    </div>
  );
};

export const MeetOurVolunteers = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/public/volunteers');
        setItems(data || []);
      } catch { /* silent */ }
      finally { setLoading(false); }
    })();
  }, []);

  if (loading || items.length === 0) return null;

  return (
    <section id="summit-volunteers" data-testid="meet-our-volunteers" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col items-start gap-3">
          <div className="w-11 h-11 rounded-xl bg-aawta-magenta text-white flex items-center justify-center">
            <HeartHandshake className="h-5 w-5" />
          </div>
          <span className="overline text-aawta-magenta">Volunteer Team</span>
          <h2 className="font-display font-bold text-4xl md:text-5xl text-aawta-navy tracking-tight leading-[1.1]">
            Meet Our 2026 Summit Volunteer Team
          </h2>
          <div className="divider-magenta" />
          <p className="text-[17px] leading-relaxed text-aawta-muted max-w-2xl">
            The dedicated volunteers making the AAWTA Building the Future Workforce
            Summit possible.
          </p>
        </div>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {items.map((it) => <VolunteerCard key={it.id} item={it} />)}
        </div>
      </div>
    </section>
  );
};

export default MeetOurVolunteers;
